import script from "./SoilChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./SoilChart.vue?vue&type=script&setup=true&lang=ts"

import "./SoilChart.vue?vue&type=style&index=0&id=21fc47f6&lang=sass"

const __exports__ = script;

export default __exports__